import React, {
    ChangeEvent,
    memo,
    useCallback,
    useEffect,
    useState,
  } from "react";
import { Input } from "@/components/ui/input";
  
  const InputField = ({
    item,
    onFocus,
    onBlur,
    other_inputs,
    isActionDemo,
    isIndicatorDemo,
    placeholder,
    id,
  }:any) => {
    const [value, setValue] = useState( item.value? item.value :item.default_value);
    const [error, setError] = useState("");
  
  
    useEffect(() => {
      if (value !== item?.value) setValue(item?.value);
    }, [item?.value]);
    return (
      <>
        <Input
          className="nodrag"
          type="text"
          value={value}
          disabled
          max={item.max_value}
          onFocus={onFocus}
          placeholder={placeholder ?? "0"}
        />
        <span
          style={{
            color: "red",
            fontSize: "10px",
          }}
        >
          {error}
        </span>
      </>
    );
  };
  
  export default memo(InputField);
  